import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NotificationType } from 'types/notification';

interface NotificationsPayload extends Omit<PayloadAction, 'payload'> {
  payload: { notifications: NotificationType[] };
}

interface NotificationPayload extends Omit<PayloadAction, 'payload'> {
  payload: { notification: NotificationType };
}

const initialValue: NotificationType[] = [];

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    value: initialValue,
  },
  reducers: {
    add: (state, action: NotificationPayload) => {
      const { notification } = action.payload;
      state.value = [
        ...state.value,
        {
          id: notification.id,
          title: notification.title,
          description: notification.description,
          level: notification.level,
          latlng: notification.latlng,
          occurrence: notification.occurrence,
          occur: notification.occur,
          timestamp: notification.timestamp,
        },
      ];
    },
    change: (state, action: NotificationPayload) => {
      const { notification } = action.payload;
      state.value = state.value.map((n) => {
        if (n.id === notification.id) {
          return notification;
        } else {
          return n;
        }
      });
    },
    remove: (state, action: NotificationPayload) => {
      const { notification } = action.payload;
      state.value = state.value.filter((n) => n.id !== notification.id);
    },
    replace: (state, action: NotificationsPayload) => {
      state.value = action.payload.notifications;
    },
  },
});

// Action creators are generated for each case reducer function
export const { add, change, remove, replace } = notificationsSlice.actions;
export const selectAllNotifications = (state) => state.notifications;

export default notificationsSlice.reducer;
